import { values } from '../_helpers'

const _enum = {
  delicate: 0,
  creamy: 1,
  aggressive: 2,
  NA: 3
}

const mousse = { ..._enum, name: 'mousse', values: values(_enum) }

export {
  mousse
}
